import React from 'react';

import type { Event, GeneralEvent } from '@vlabs/api/luna-api/model';
import { useDispatch } from 'react-redux';

import { setViewedNotifyIds } from '../store.js';
import { useSelectedWorkspaceEvent } from '../useSelectedWorkspaceEvent';
import {
  EventPreviewCrowd,
  EventPreviewFire,
  EventPreviewFight,
  EventPreviewWeapon,
  EventPreviewFacecover,
  EventPreviewBag,
  EventPreviewLying,
  EventPreviewHandsup,
  EventPreviewFall,
  EventPreviewFaceBody,
} from './event-preview';

interface EventType {
  event: Event | GeneralEvent;
}

export function EventPreview({
  event,
}: EventType): React.JSX.Element | null {
  const { setSelectedEvent, clearSelectedEvent, selectedEventId } = useSelectedWorkspaceEvent();
  const dispatch = useDispatch();

  const onClick = ({ event: $event }: EventType) => {
    if (selectedEventId === $event?.event_id || selectedEventId === $event?.event?.event_id) {
      clearSelectedEvent();
      return;
    }

    setSelectedEvent($event);
    dispatch(setViewedNotifyIds({ id: $event?.event_id ?? $event?.event?.event_id }));
  };

  switch (event?.event_type) {
    case 'crowd':
      return (
        <EventPreviewCrowd
          event={event}
          onClick={onClick}
        />
      );
    case 'fight':
      return (
        <EventPreviewFight
          event={event}
          onClick={onClick}
        />
      );
    case 'fire':
      return (
        <EventPreviewFire
          event={event}
          onClick={onClick}
        />
      );
    case 'weapon':
      return (
        <EventPreviewWeapon
          event={event}
          onClick={onClick}
        />
      );
    case 'facecover':
    case 'balaclava':
    case 'niqab':
    case 'other':
      return (
        <EventPreviewFacecover
          event={event}
          onClick={onClick}
        />
      );
    case 'bag':
      return (
        <EventPreviewBag
          event={event}
          onClick={onClick}
        />
      );
    case 'lying':
      return (
        <EventPreviewLying
          event={event}
          onClick={onClick}
        />
      );
    case 'handsup':
      return (
        <EventPreviewHandsup
          event={event}
          onClick={onClick}
        />
      );
    case 'fall':
      return (
        <EventPreviewFall
          event={event}
          onClick={onClick}
        />
      );
    default:
      if (event?.event_type) {
        console.warn(`[EventPreview] Неизвестный тип аналитики: "${event.event_type}"`);
        return null;
      }

      return (
        <EventPreviewFaceBody
          event={event}
          onClick={onClick}
        />
      );
  }
}
